export function getDefaultTitle(counters) {
  const kpiLabels = counters.filter(Boolean).map((counter) => counter.name);

  if (kpiLabels.length === 0) {
    return 'Untitled chart';
  }

  if (kpiLabels.length === 1) {
    return kpiLabels[0];
  }

  const lastKpiLabel = kpiLabels.pop();

  return `${kpiLabels.join(', ')} and ${lastKpiLabel}`;
}

export function trimTitle(title, maxLength = 57) {
  const trimmedTitle = title.trim();
  if (trimmedTitle.length > maxLength) {
    return `${trimmedTitle.substring(0, maxLength - 3)}...`;
  }

  return trimmedTitle;
}

export function trimLabel(label, options = {}) {
  let { maxLength, prefixLength = 12, suffixLength = 4, ellipsis = '...' } = options;

  maxLength = maxLength ?? prefixLength + ellipsis.length + suffixLength;

  if (label.length <= maxLength) return label;

  const prefix = label.substring(0, prefixLength);
  const suffix = label.substring(label.length - suffixLength);

  return `${prefix}${ellipsis}${suffix}`;
}
